module.exports = {"Description":"SZ : ANNN","RedundantCharacters":" -","ValidationRegex":"^[a-zA-Z]{1}[0-9]{3}$","TestData":{"Valid":["S123","a789"],"Invalid":["F1234","D12"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/SZ.json
// module id = 4488
// module chunks = 11